import MuiTooltip from '@mui/material/Tooltip'

function Tooltip(props) {
  return (
    <MuiTooltip
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'common.black',
            border: 1,
            borderColor: 'divider'
          }
        },
      }}
      {...props}
    />
  )
}

export default Tooltip
